import { render, staticRenderFns } from "./time-page.vue?vue&type=template&id=566874f5&scoped=true&"
import script from "./time-page.vue?vue&type=script&lang=js&"
export * from "./time-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566874f5",
  null
  
)

export default component.exports